import { render } from "./button.vue?vue&type=template&id=2c94fe49&scoped=true"
import script from "./button.vue?vue&type=script&setup=true&lang=js"
export * from "./button.vue?vue&type=script&setup=true&lang=js"

import "./button.vue?vue&type=style&index=0&id=2c94fe49&lang=scss&scoped=true"
import "./button.vue?vue&type=style&index=1&id=2c94fe49&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c94fe49"],['__file',"resources/js/v2/components/form/button.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c94fe49"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c94fe49', __exports__)) {
    console.log('reload')
    api.reload('2c94fe49', __exports__)
  }
  
  module.hot.accept("./button.vue?vue&type=template&id=2c94fe49&scoped=true", () => {
    console.log('re-render')
    api.rerender('2c94fe49', render)
  })

}


export default __exports__